import { isLocalhost } from 'src/utils/url'
import { captureException, withScope } from '@sentry/browser'
import { redactSensitiveKeys } from '@dentalux/ui-library-core/utils'

const captureExceptionWithResponse = (errorMessage: string, response: unknown, additionalData?: unknown): void => {
  if (!isLocalhost) {
    withScope((scope) => {
      const redactedResponse = redactSensitiveKeys(response)

      scope.setExtra('response', redactedResponse)
      scope.setExtra('additionalData', additionalData)

      captureException(new Error(errorMessage))
    })
  }
}

export default captureExceptionWithResponse
